// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.DashboardProfessional_dashboard__2Fe8o {
  width: 100%;
  font-family: "Sora", sans-serif;
  color: #13231d;
  padding-bottom: 40px;
}
@media (max-width: 768px) {
  .DashboardProfessional_dashboard__2Fe8o {
    padding: 10px 0;
  }
}
.DashboardProfessional_dashboard__grid__6cYsV {
  display: grid;
  grid-template-columns: 1.8fr 1fr;
  gap: 22px;
  margin-top: 24px;
}
@media (max-width: 1024px) {
  .DashboardProfessional_dashboard__grid__6cYsV {
    grid-template-columns: 1fr;
  }
}
.DashboardProfessional_dashboard__sidebar__9u4az {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.DashboardProfessional_section-head__wWEDM {
  margin-bottom: 24px;
}
.DashboardProfessional_section-head__wWEDM h3 {
  font-size: 28px;
  font-weight: 800;
  margin: 0;
  letter-spacing: -0.02em;
}
.DashboardProfessional_section-head__wWEDM p {
  margin: 4px 0 0;
  font-size: 16px;
  color: rgba(19, 35, 29, 0.68);
}
@media (max-width: 768px) {
  .DashboardProfessional_section-head__wWEDM p {
    font-size: 14px;
  }
}

.DashboardProfessional_journey__3gYYE {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.52), rgba(241, 246, 242, 0.92));
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 24px;
  padding: 28px 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  margin-bottom: 30px;
}
.DashboardProfessional_journey__head__h5qLI {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;
}
.DashboardProfessional_journey__mark__Smwrz {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
  color: #67a27f;
  font-weight: 800;
  font-size: 20px;
}
.DashboardProfessional_journey__title__hTb3X {
  margin: 0;
  font-size: 36px;
  letter-spacing: -0.04em;
  line-height: 1.1;
  font-weight: 800;
}
.DashboardProfessional_journey__subtitle__VIVI6 {
  margin: 8px 0 0;
  font-size: 16px;
  color: rgba(19, 35, 29, 0.68);
}

.DashboardProfessional_metrics__UkwjT {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 16px;
}
@media (max-width: 600px) {
  .DashboardProfessional_metrics__UkwjT {
    grid-template-columns: 1fr;
  }
}

.DashboardProfessional_metric__-BBwO {
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 18px;
  padding: 22px 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  display: flex;
  align-items: center;
  gap: 18px;
  transition: transform 0.2s ease;
}
@media (max-width: 768px) {
  .DashboardProfessional_metric__-BBwO {
    padding: 18px 20px;
    gap: 14px;
  }
}
.DashboardProfessional_metric__-BBwO:hover {
  transform: translateY(-2px);
}
.DashboardProfessional_metric--income__AmgLB, .DashboardProfessional_metric--appointments__EOpsb {
  box-shadow: inset 4px 0 0 rgba(214, 166, 64, 0.58), 0 10px 30px rgba(0, 0, 0, 0.03);
}
.DashboardProfessional_metric__icon-box__aiugq {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: rgba(214, 166, 64, 0.1);
  color: #8a6516;
}
.DashboardProfessional_metric__label__wBEAg {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(19, 35, 29, 0.6);
}
.DashboardProfessional_metric__value__5vxys {
  margin-top: 4px;
  font-size: 24px;
  font-weight: 800;
  letter-spacing: -0.02em;
}
@media (max-width: 480px) {
  .DashboardProfessional_metric__value__5vxys {
    font-size: 20px;
  }
}
.DashboardProfessional_metric__note__z\\+tlD {
  font-size: 12px;
  color: #8a6516;
  font-weight: 700;
  margin-top: 4px;
  display: block;
}
@media (max-width: 480px) {
  .DashboardProfessional_metric__note__z\\+tlD {
    font-size: 11px;
  }
}
.DashboardProfessional_metric__content__-fa7W {
  display: flex;
  flex-direction: column;
}

.DashboardProfessional_card-widget__9SsC5 {
  background: #ffffff;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 24px;
  padding: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
}
.DashboardProfessional_card-widget__header__GPQ7y {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(16, 25, 21, 0.04);
  padding-bottom: 12px;
}
.DashboardProfessional_card-widget__icon__xUxfd {
  color: rgba(19, 35, 29, 0.4);
}
.DashboardProfessional_card-widget__title__H81uS {
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #13231d;
}
.DashboardProfessional_card-widget--dark__XVfg4 {
  background: #13231d;
  color: #fff;
}
.DashboardProfessional_card-widget--dark__XVfg4 .DashboardProfessional_card-widget__title__H81uS, .DashboardProfessional_card-widget--dark__XVfg4 .DashboardProfessional_card-widget__icon__xUxfd {
  color: #fff;
}
.DashboardProfessional_card-widget--dark__XVfg4 .DashboardProfessional_card-widget__header__GPQ7y {
  border-bottom-color: rgba(255, 255, 255, 0.1);
}

.DashboardProfessional_appointment-row__8pSZD {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px;
  background: #fbf8f5;
  border-radius: 16px;
  margin-bottom: 10px;
  transition: background 0.2s;
}
.DashboardProfessional_appointment-row__8pSZD:hover {
  background: #f0f0ec;
}
.DashboardProfessional_appointment-row__time__jj6Qb {
  text-align: center;
  min-width: 60px;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
  padding-right: 12px;
}
.DashboardProfessional_appointment-row__date__Utcqv {
  font-size: 10px;
  font-weight: 800;
  color: #82b194;
  display: block;
}
.DashboardProfessional_appointment-row__hour__QsSBf {
  font-size: 14px;
  font-weight: 800;
}
.DashboardProfessional_appointment-row__info__oe2OK {
  flex: 1 1;
}
.DashboardProfessional_appointment-row__name__SM18J {
  font-weight: 700;
  font-size: 14px;
  display: block;
}
.DashboardProfessional_appointment-row__type__7pc9s {
  font-size: 12px;
  color: rgba(19, 35, 29, 0.5);
}
.DashboardProfessional_appointment-row__btn__lCf\\+r {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid rgba(16, 25, 21, 0.08);
  display: grid;
  place-items: center;
  color: #82b194;
}
.DashboardProfessional_appointment-row__btn__lCf\\+r:hover {
  background: #82b194;
  color: #fff;
}

.DashboardProfessional_occupancy__TGdfh {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}
.DashboardProfessional_occupancy__chart__GmJrV {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: conic-gradient(#82b194 0% 75%, #f0f0ec 75% 100%);
  display: grid;
  place-items: center;
}
.DashboardProfessional_occupancy__center__8q8u9 {
  width: 90px;
  height: 90px;
  background: #fff;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-weight: 800;
  font-size: 20px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
}
.DashboardProfessional_occupancy__legend__KDEyJ {
  width: 100%;
  list-style: none;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
}
.DashboardProfessional_occupancy__legend__KDEyJ li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.DashboardProfessional_dashboard__grid__6cYsV {
  display: grid;
  grid-template-columns: 1.8fr 1fr;
  gap: 24px;
  margin-top: 24px;
}
@media (max-width: 1024px) {
  .DashboardProfessional_dashboard__grid__6cYsV {
    grid-template-columns: 1fr;
  }
}

.DashboardProfessional_widget-card__cwwHf {
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  transition: transform 0.2s ease;
}
@media (max-width: 768px) {
  .DashboardProfessional_widget-card__cwwHf {
    padding: 24px 20px;
  }
}
.DashboardProfessional_widget-card__cwwHf:hover {
  transform: translateY(-2px);
}
.DashboardProfessional_widget-card__header__jXVl2 {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}
.DashboardProfessional_widget-card__icon-box__9PmfF {
  width: 48px;
  height: 48px;
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 14px;
  display: grid;
  place-items: center;
  color: rgba(19, 35, 29, 0.68);
  flex-shrink: 0;
}
@media (max-width: 480px) {
  .DashboardProfessional_widget-card__icon-box__9PmfF {
    width: 40px;
    height: 40px;
    border-radius: 10px;
  }
  .DashboardProfessional_widget-card__icon-box__9PmfF svg {
    font-size: 20px !important;
  }
}
.DashboardProfessional_widget-card__icon-box--green__XRUTW {
  background: rgba(130, 177, 148, 0.1);
  color: #82B194;
}
.DashboardProfessional_widget-card__eyebrow__oxfgH {
  display: block;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: #82B194;
  margin-bottom: 2px;
}
.DashboardProfessional_widget-card__title__eSZ2l {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: #13231D;
  letter-spacing: -0.01em;
}
.DashboardProfessional_widget-card--dark__byElH {
  background: #13231D;
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}
.DashboardProfessional_widget-card--dark__byElH .DashboardProfessional_widget-card__title__eSZ2l, .DashboardProfessional_widget-card--dark__byElH .DashboardProfessional_widget-card__eyebrow__oxfgH {
  color: #fff;
}
.DashboardProfessional_widget-card--dark__byElH .DashboardProfessional_widget-card__icon-box__9PmfF {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}

.DashboardProfessional_appointment-item__Vbkoh {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 16px 20px;
  background: #F7F5F1;
  border-radius: 18px;
  margin-bottom: 12px;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}
@media (max-width: 600px) {
  .DashboardProfessional_appointment-item__Vbkoh {
    gap: 12px;
    padding: 14px 16px;
  }
}
.DashboardProfessional_appointment-item__Vbkoh:hover {
  background: #fff;
  border-color: rgba(130, 177, 148, 0.3);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
}
.DashboardProfessional_appointment-item__time-box__5F4p0 {
  text-align: center;
  min-width: 70px;
  padding-right: 16px;
  border-right: 1px solid rgba(16, 25, 21, 0.06);
}
@media (max-width: 480px) {
  .DashboardProfessional_appointment-item__time-box__5F4p0 {
    min-width: 60px;
    padding-right: 10px;
  }
}
.DashboardProfessional_appointment-item__date__XMX7Q {
  font-size: 11px;
  font-weight: 800;
  color: #82B194;
  display: block;
  text-transform: uppercase;
}
@media (max-width: 480px) {
  .DashboardProfessional_appointment-item__date__XMX7Q {
    font-size: 9px;
  }
}
.DashboardProfessional_appointment-item__hour__UybPj {
  font-size: 15px;
  font-weight: 800;
  color: #13231D;
}
@media (max-width: 480px) {
  .DashboardProfessional_appointment-item__hour__UybPj {
    font-size: 13px;
  }
}
.DashboardProfessional_appointment-item__info__0gRQm {
  flex: 1 1;
}
.DashboardProfessional_appointment-item__patient__kiUWc {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #13231D;
}
@media (max-width: 480px) {
  .DashboardProfessional_appointment-item__patient__kiUWc {
    font-size: 14px;
  }
}
.DashboardProfessional_appointment-item__reason__i3nl5 {
  margin: 2px 0 0;
  font-size: 13px;
  color: rgba(19, 35, 29, 0.68);
  font-weight: 500;
}
@media (max-width: 480px) {
  .DashboardProfessional_appointment-item__reason__i3nl5 {
    font-size: 12px;
  }
}
.DashboardProfessional_appointment-item__link__Hy\\+TA {
  width: 36px;
  height: 36px;
  background: #fff;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 10px;
  display: grid;
  place-items: center;
  color: #82B194;
  transition: all 0.2s;
}
.DashboardProfessional_appointment-item__link__Hy\\+TA:hover {
  background: #82B194;
  color: #fff;
  transform: scale(1.05);
}

.DashboardProfessional_occupancy__TGdfh {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}
.DashboardProfessional_occupancy__chart__GmJrV {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: conic-gradient(#82B194 0% var(--occupancy-rate, 0%), #F7F5F1 var(--occupancy-rate, 0%) 100%);
  display: grid;
  place-items: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}
.DashboardProfessional_occupancy__center__8q8u9 {
  width: 105px;
  height: 105px;
  background: #fff;
  border-radius: 50%;
  display: grid;
  place-items: center;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.05);
}
.DashboardProfessional_occupancy__value__KJpI\\+ {
  font-size: 24px;
  font-weight: 800;
  color: #13231D;
}
.DashboardProfessional_occupancy__legend__KDEyJ {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.DashboardProfessional_legend-item__16n8o {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  color: rgba(19, 35, 29, 0.68);
}
.DashboardProfessional_legend-item__dot__Hj3Fa {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
  display: inline-block;
}
.DashboardProfessional_legend-item__dot--occupied__IPXr0 {
  background: #82B194;
}
.DashboardProfessional_legend-item__dot--free__TSRVU {
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.08);
}

.DashboardProfessional_agenda-list__p8KW0 {
  display: flex;
  flex-direction: column;
}
.DashboardProfessional_agenda-list--empty__wBSoL {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 40px;
  background: rgba(130, 177, 148, 0.03);
  border-radius: 24px;
  border: 2px dashed rgba(130, 177, 148, 0.15);
  text-align: center;
  margin: 10px 0;
  transition: all 0.3s ease;
}
.DashboardProfessional_agenda-list--empty__wBSoL:hover {
  background: rgba(130, 177, 148, 0.05);
  border-color: rgba(130, 177, 148, 0.25);
}
.DashboardProfessional_agenda-list--empty__icon-box__Xg2Eq {
  width: 64px;
  height: 64px;
  background: #fff;
  border-radius: 50%;
  display: grid;
  place-items: center;
  color: rgba(130, 177, 148, 0.4);
  margin-bottom: 20px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
}
.DashboardProfessional_agenda-list--empty__title__IqGg9 {
  font-size: 18px;
  font-weight: 800;
  color: #13231D;
  margin: 0 0 8px;
  letter-spacing: -0.02em;
}
.DashboardProfessional_agenda-list--empty__text__1CewF {
  font-size: 14px;
  color: rgba(19, 35, 29, 0.68);
  margin: 0;
  max-width: 280px;
  line-height: 1.5;
}

.DashboardProfessional_wallet-preview__label__fXDKg {
  font-size: 13px;
  opacity: 0.6;
  display: block;
  margin-bottom: 8px;
}
.DashboardProfessional_wallet-preview__balance__di9ZA {
  font-size: 32px;
  font-weight: 800;
  margin: 0 0 24px;
  letter-spacing: -0.04em;
  color: #fff;
}
@media (max-width: 480px) {
  .DashboardProfessional_wallet-preview__balance__di9ZA {
    font-size: 26px;
    margin-bottom: 16px;
  }
}
.DashboardProfessional_wallet-preview__btn__1\\+rAN {
  display: inline-flex;
  color: #82B194;
  text-decoration: none;
  font-weight: 800;
  font-size: 13px;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  transition: all 0.2s;
}
.DashboardProfessional_wallet-preview__btn__1\\+rAN:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.DashboardProfessional_patient-to-pro-banner__UseMr {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 24px;
}

.DashboardProfessional_patient-to-pro-btn__Q4cNw {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #f1f5f9;
  color: #475569;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.2s ease;
  border: 1px solid #e2e8f0;
}
.DashboardProfessional_patient-to-pro-btn__Q4cNw:hover {
  background-color: #e2e8f0;
  color: #0f172a;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/DashboardProfessional/DashboardProfessional.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAHA;EACE,WAAA;EACA,+BAAA;EACA,cAAA;EACA,oBAAA;AAMF;AAJE;EANF;IAOI,eAAA;EAOF;AACF;AALE;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,gBAAA;AAOJ;AALI;EANF;IAOI,0BAAA;EAQJ;AACF;AALE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAOJ;;AAHA;EACE,mBAAA;AAMF;AALE;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;AAOJ;AALE;EACE,eAAA;EACA,eAAA;EACA,6BAAA;AAOJ;AANI;EAJF;IAKI,eAAA;EASJ;AACF;;AALA;EACE,wFAAA;EACA,wCAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CDEY;ECDZ,mBAAA;AAQF;AANE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAQJ;AALE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAOJ;AAJE;EACE,SAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AAMJ;AAHE;EACE,eAAA;EACA,eAAA;EACA,6BAAA;AAKJ;;AADA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,gBAAA;AAIF;AAFE;EANF;IAOI,0BAAA;EAKF;AACF;;AAFA;EACE,mBD/FqB;ECgGrB,wCAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CDpDY;ECqDZ,aAAA;EACA,mBAAA;EACA,SAAA;EACA,+BAAA;AAKF;AAHE;EAXF;IAYI,kBAAA;IACA,SAAA;EAMF;AACF;AAJE;EACE,2BAAA;AAMJ;AAHE;EACE,mFAAA;AAKJ;AAFE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,cAAA;AAIJ;AADE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,4BAAA;AAGJ;AAAE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAEJ;AADI;EALF;IAMI,eAAA;EAIJ;AACF;AADE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAGJ;AAFI;EANF;IAOI,eAAA;EAKJ;AACF;AAFE;EACE,aAAA;EACA,sBAAA;AAIJ;;AAAA;EACE,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,2CDzHY;AC4Hd;AADE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,+CAAA;EACA,oBAAA;AAGJ;AAAE;EAAU,4BAAA;AAGZ;AAFE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAIJ;AADE;EACE,mBAAA;EACA,WAAA;AAGJ;AAFI;EAA0C,WAAA;AAK9C;AAJI;EAAuB,6CAAA;AAO3B;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;AAMF;AAJE;EAAU,mBAAA;AAOZ;AALE;EACE,kBAAA;EACA,eAAA;EACA,2CAAA;EACA,mBAAA;AAOJ;AAJE;EAAU,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,cAAA;AAU/D;AATE;EAAU,eAAA;EAAiB,gBAAA;AAa7B;AAXE;EAAU,SAAA;AAcZ;AAbE;EAAU,gBAAA;EAAkB,eAAA;EAAiB,cAAA;AAkB/C;AAjBE;EAAU,eAAA;EAAiB,4BAAA;AAqB7B;AAnBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAqBJ;AApBI;EAAU,mBAAA;EAAqB,WAAA;AAwBnC;;AApBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAuBF;AArBE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,4DAAA;EACA,aAAA;EACA,mBAAA;AAuBJ;AApBE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,+CAAA;AAsBJ;AAnBE;EACE,WAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AAqBJ;AApBI;EAAK,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,kBAAA;AA0B7E;;AApBA;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,gBAAA;AAuBF;AArBE;EANF;IAOI,0BAAA;EAwBF;AACF;;AArBA;EACE,mBD9RqB;EC+RrB,wCAAA;EACA,mBAxSa;EAySb,aAAA;EACA,2CDnPY;ECoPZ,aAAA;EACA,sBAAA;EACA,+BAAA;AAwBF;AAtBE;EAVF;IAWI,kBAAA;EAyBF;AACF;AAvBE;EACE,2BAAA;AAyBJ;AAtBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAwBJ;AArBE;EACE,WAAA;EACA,YAAA;EACA,mBDzTmB;EC0TnB,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BDvTmB;ECwTnB,cAAA;AAuBJ;AArBI;EAXF;IAYI,WAAA;IACA,YAAA;IACA,mBAAA;EAwBJ;EAvBI;IAAM,0BAAA;EA0BV;AACF;AAxBI;EACI,oCAAA;EACA,cDlVe;AC4WvB;AAtBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cD5VmB;EC6VnB,kBAAA;AAwBJ;AArBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cDvVmB;ECwVnB,uBAAA;AAuBJ;AApBE;EACE,mBD5VmB;EC6VnB,sCAAA;EACA,WAAA;AAsBJ;AApBI;EAA6C,WAAA;AAuBjD;AAtBI;EAAyB,oCAAA;EAAmC,WAAA;EAAa,yBAAA;AA2B7E;;AAvBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBD/WqB;ECgXrB,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;AA0BF;AAxBE;EAXF;IAYI,SAAA;IACA,kBAAA;EA2BF;AACF;AAzBE;EACE,gBAAA;EACA,sCAAA;EACA,0CAAA;AA2BJ;AAxBE;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,8CAAA;AA0BJ;AAxBI;EANF;IAOI,eAAA;IACA,mBAAA;EA2BJ;AACF;AAxBE;EACE,eAAA;EACA,gBAAA;EACA,cDvZmB;ECwZnB,cAAA;EACA,yBAAA;AA0BJ;AAzBI;EANF;IAM8B,cAAA;EA6B9B;AACF;AA5BE;EACE,eAAA;EACA,gBAAA;EACA,cDlZmB;ACgbvB;AA7BI;EAJF;IAI8B,eAAA;EAiC9B;AACF;AA/BE;EAAU,SAAA;AAkCZ;AAjCE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cD3ZmB;AC8bvB;AAlCI;EALF;IAK8B,eAAA;EAsC9B;AACF;AArCE;EACE,eAAA;EACA,eAAA;EACA,6BD/ZmB;ECganB,gBAAA;AAuCJ;AAtCI;EALF;IAK8B,eAAA;EA0C9B;AACF;AAxCE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,cD3bmB;EC4bnB,oBAAA;AA0CJ;AAxCI;EACI,mBD/be;ECgcf,WAAA;EACA,sBAAA;AA0CR;;AArCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAwCF;AAtCE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,wGAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;AAwCJ;AArCE;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,+CAAA;AAuCJ;AApCE;EAAW,eAAA;EAAiB,gBAAA;EAAkB,cDndzB;AC4fvB;AAvCE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAyCJ;;AArCA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BDjemB;ACygBvB;AAtCI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;AAwCR;AAtCQ;EAAc,mBDzfC;ACkiBvB;AAxCQ;EAAU,mBDlfK;ECkfsB,wCAAA;AA4C7C;;AAxCA;EACE,aAAA;EACA,sBAAA;AA2CF;AAzCE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qCAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;AA2CJ;AAzCI;EACE,qCAAA;EACA,uCAAA;AA2CN;AAxCI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2CAAA;AA0CN;AAvCI;EACE,eAAA;EACA,gBAAA;EACA,cDthBiB;ECuhBjB,eAAA;EACA,uBAAA;AAyCN;AAtCI;EACE,eAAA;EACA,6BD3hBiB;EC4hBjB,SAAA;EACA,gBAAA;EACA,gBAAA;AAwCN;;AAlCE;EAAW,eAAA;EAAiB,YAAA;EAAc,cAAA;EAAgB,kBAAA;AAyC5D;AAxCE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AA0CJ;AAzCI;EANF;IAOI,eAAA;IACA,mBAAA;EA4CJ;AACF;AA1CE;EACE,oBAAA;EACA,cDjkBmB;ECkkBnB,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,qCAAA;EACA,mBAAA;EACA,oBAAA;AA4CJ;AA1CI;EAAU,oCAAA;EAAmC,WAAA;AA8CjD;;AA1CA;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;AA6CJ;;AA1CA;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;AA6CJ;AA3CI;EACI,yBAAA;EACA,cAAA;AA6CR","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../assets/styles/variables';\n\n$bw-bg: $color-bg;\n$bw-surface: $sidebar-submenu-bg;\n$bw-border: $color-border;\n$bw-primary: $color-primary;\n$bw-gold: $color-gold;\n$bw-shadow:$shadow-card;\n$bw-surface-2: $color-surface;\n$bw-text: $text-main;\n$bw-muted: $text-secondary;\n$bw-radius-xl: 24px;\n\n.dashboard {\n  width: 100%;\n  font-family: \"Sora\", sans-serif;\n  color: #13231d;\n  padding-bottom: 40px;\n\n  @media (max-width: 768px) {\n    padding: 10px 0;\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: 1.8fr 1fr;\n    gap: 22px;\n    margin-top: 24px;\n\n    @media (max-width: 1024px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__sidebar {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n}\n\n.section-head {\n  margin-bottom: 24px;\n  h3 {\n    font-size: 28px;\n    font-weight: 800;\n    margin: 0;\n    letter-spacing: -0.02em;\n  }\n  p {\n    margin: 4px 0 0;\n    font-size: 16px;\n    color: rgba(19, 35, 29, 0.68);\n    @media (max-width: 768px) {\n      font-size: 14px;\n    }\n  }\n}\n\n.journey {\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.52), rgba(241, 246, 242, 0.92));\n  border: 1px solid $bw-border;\n  border-radius: 24px;\n  padding: 28px 30px;\n  box-shadow: $bw-shadow;\n  margin-bottom: 30px;\n\n  &__head {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n    margin-bottom: 24px;\n  }\n\n  &__mark {\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n    display: grid;\n    place-items: center;\n    background: #ffffff;\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);\n    color: #67a27f;\n    font-weight: 800;\n    font-size: 20px;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 36px;\n    letter-spacing: -0.04em;\n    line-height: 1.1;\n    font-weight: 800;\n  }\n\n  &__subtitle {\n    margin: 8px 0 0;\n    font-size: 16px;\n    color: rgba(19, 35, 29, 0.68);\n  }\n}\n\n.metrics {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  margin-top: 16px;\n\n  @media (max-width: 600px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.metric {\n  background: $color-surface;\n  border: 1px solid $bw-border;\n  border-radius: 18px;\n  padding: 22px 24px;\n  box-shadow: $bw-shadow;\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  transition: transform 0.2s ease;\n\n  @media (max-width: 768px) {\n    padding: 18px 20px;\n    gap: 14px;\n  }\n\n  &:hover {\n    transform: translateY(-2px);\n  }\n\n  &--income, &--appointments {\n    box-shadow: inset 4px 0 0 rgba(214, 166, 64, 0.58), $bw-shadow;\n  }\n\n  &__icon-box {\n    width: 46px;\n    height: 46px;\n    border-radius: 50%;\n    display: grid;\n    place-items: center;\n    background: rgba(214, 166, 64, 0.1);\n    color: #8a6516;\n  }\n\n  &__label {\n    font-size: 11px;\n    font-weight: 800;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba(19, 35, 29, 0.6);\n  }\n\n  &__value {\n    margin-top: 4px;\n    font-size: 24px;\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    @media (max-width: 480px) {\n      font-size: 20px;\n    }\n  }\n\n  &__note {\n    font-size: 12px;\n    color: #8a6516;\n    font-weight: 700;\n    margin-top: 4px;\n    display: block;\n    @media (max-width: 480px) {\n      font-size: 11px;\n    }\n  }\n\n  &__content{\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.card-widget {\n  background: #ffffff;\n  border: 1px solid $bw-border;\n  border-radius: 24px;\n  padding: 24px;\n  box-shadow: $bw-shadow;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 20px;\n    border-bottom: 1px solid rgba(16, 25, 21, 0.04);\n    padding-bottom: 12px;\n  }\n\n  &__icon { color: rgba(19, 35, 29, 0.4); }\n  &__title {\n    font-size: 13px;\n    font-weight: 800;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: #13231d;\n  }\n\n  &--dark {\n    background: #13231d;\n    color: #fff;\n    .card-widget__title, .card-widget__icon { color: #fff; }\n    .card-widget__header { border-bottom-color: rgba(255,255,255,0.1); }\n  }\n}\n\n.appointment-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 14px;\n  background: #fbf8f5;\n  border-radius: 16px;\n  margin-bottom: 10px;\n  transition: background 0.2s;\n\n  &:hover { background: #f0f0ec; }\n\n  &__time {\n    text-align: center;\n    min-width: 60px;\n    border-right: 1px solid rgba(0,0,0,0.05);\n    padding-right: 12px;\n  }\n\n  &__date { font-size: 10px; font-weight: 800; color: #82b194; display: block; }\n  &__hour { font-size: 14px; font-weight: 800; }\n  \n  &__info { flex: 1; }\n  &__name { font-weight: 700; font-size: 14px; display: block; }\n  &__type { font-size: 12px; color: rgba(19, 35, 29, 0.5); }\n\n  &__btn {\n    width: 32px;\n    height: 32px;\n    border-radius: 10px;\n    background: #fff;\n    border: 1px solid $bw-border;\n    display: grid;\n    place-items: center;\n    color: #82b194;\n    &:hover { background: #82b194; color: #fff; }\n  }\n}\n\n.occupancy {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n\n  &__chart {\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    background: conic-gradient(#82b194 0% 75%, #f0f0ec 75% 100%);\n    display: grid;\n    place-items: center;\n  }\n\n  &__center {\n    width: 90px;\n    height: 90px;\n    background: #fff;\n    border-radius: 50%;\n    display: grid;\n    place-items: center;\n    font-weight: 800;\n    font-size: 20px;\n    box-shadow: inset 0 2px 4px rgba(0,0,0,0.05);\n  }\n\n  &__legend {\n    width: 100%;\n    list-style: none;\n    padding: 0;\n    font-size: 13px;\n    font-weight: 600;\n    li { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }\n  }\n}\n\n\n\n.dashboard__grid {\n  display: grid;\n  grid-template-columns: 1.8fr 1fr;\n  gap: 24px;\n  margin-top: 24px;\n\n  @media (max-width: 1024px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.widget-card {\n  background: $color-surface;\n  border: 1px solid $bw-border;\n  border-radius: $bw-radius-xl;\n  padding: 32px;\n  box-shadow: $bw-shadow;\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.2s ease;\n\n  @media (max-width: 768px) {\n    padding: 24px 20px;\n  }\n\n  &:hover {\n    transform: translateY(-2px);\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 24px;\n  }\n\n  &__icon-box {\n    width: 48px;\n    height: 48px;\n    background: $bw-surface-2;\n    border: 1px solid $bw-border;\n    border-radius: 14px;\n    display: grid;\n    place-items: center;\n    color: $bw-muted;\n    flex-shrink: 0;\n\n    @media (max-width: 480px) {\n      width: 40px;\n      height: 40px;\n      border-radius: 10px;\n      svg { font-size: 20px !important; }\n    }\n\n    &--green {\n        background: rgba($bw-primary, 0.1);\n        color: $bw-primary;\n    }\n  }\n\n  &__eyebrow {\n    display: block;\n    font-size: 10px;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.12em;\n    color: $bw-primary;\n    margin-bottom: 2px;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 800;\n    color: $bw-text;\n    letter-spacing: -0.01em;\n  }\n\n  &--dark {\n    background: $bw-text;\n    border-color: rgba(255,255,255, 0.1);\n    color: #fff;\n\n    .widget-card__title, .widget-card__eyebrow { color: #fff; }\n    .widget-card__icon-box { background: rgba(255,255,255,0.1); color: #fff; border-color: transparent; }\n  }\n}\n\n.appointment-item {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 16px 20px;\n  background: $bw-surface-2;\n  border-radius: 18px;\n  margin-bottom: 12px;\n  transition: all 0.2s ease;\n  border: 1px solid transparent;\n\n  @media (max-width: 600px) {\n    gap: 12px;\n    padding: 14px 16px;\n  }\n\n  &:hover {\n    background: #fff;\n    border-color: rgba($bw-primary, 0.3);\n    box-shadow: 0 8px 20px rgba(0,0,0,0.04);\n  }\n\n  &__time-box {\n    text-align: center;\n    min-width: 70px;\n    padding-right: 16px;\n    border-right: 1px solid rgba(16, 25, 21, 0.06);\n\n    @media (max-width: 480px) {\n      min-width: 60px;\n      padding-right: 10px;\n    }\n  }\n\n  &__date { \n    font-size: 11px; \n    font-weight: 800; \n    color: $bw-primary; \n    display: block; \n    text-transform: uppercase; \n    @media (max-width: 480px) { font-size: 9px; }\n  }\n  &__hour { \n    font-size: 15px; \n    font-weight: 800; \n    color: $bw-text; \n    @media (max-width: 480px) { font-size: 13px; }\n  }\n\n  &__info { flex: 1; }\n  &__patient { \n    margin: 0; \n    font-size: 15px; \n    font-weight: 700; \n    color: $bw-text; \n    @media (max-width: 480px) { font-size: 14px; }\n  }\n  &__reason { \n    margin: 2px 0 0; \n    font-size: 13px; \n    color: $bw-muted; \n    font-weight: 500; \n    @media (max-width: 480px) { font-size: 12px; }\n  }\n\n  &__link {\n    width: 36px;\n    height: 36px;\n    background: #fff;\n    border: 1px solid $bw-border;\n    border-radius: 10px;\n    display: grid;\n    place-items: center;\n    color: $bw-primary;\n    transition: all 0.2s;\n\n    &:hover {\n        background: $bw-primary;\n        color: #fff;\n        transform: scale(1.05);\n    }\n  }\n}\n\n.occupancy {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n\n  &__chart {\n    width: 140px;\n    height: 140px;\n    border-radius: 50%;\n    background: conic-gradient($bw-primary 0% var(--occupancy-rate, 0%), $bw-surface-2 var(--occupancy-rate, 0%) 100%);\n    display: grid;\n    place-items: center;\n    box-shadow: 0 4px 15px rgba(0,0,0,0.05);\n  }\n\n  &__center {\n    width: 105px;\n    height: 105px;\n    background: #fff;\n    border-radius: 50%;\n    display: grid;\n    place-items: center;\n    box-shadow: inset 0 2px 8px rgba(0,0,0,0.05);\n  }\n\n  &__value { font-size: 24px; font-weight: 800; color: $bw-text; }\n\n  &__legend {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n}\n\n.legend-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 13px;\n    font-weight: 600;\n    color: $bw-muted;\n\n    &__dot {\n        width: 10px;\n        height: 10px;\n        border-radius: 50%;\n        margin-right: 8px;\n        display: inline-block;\n\n        &--occupied { background: $bw-primary; }\n        &--free { background: $bw-surface-2; border: 1px solid $bw-border; }\n    }\n}\n\n.agenda-list {\n  display: flex;\n  flex-direction: column;\n\n  &--empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 60px 40px;\n    background: rgba($bw-primary, 0.03);\n    border-radius: 24px;\n    border: 2px dashed rgba($bw-primary, 0.15);\n    text-align: center;\n    margin: 10px 0;\n    transition: all 0.3s ease;\n\n    &:hover {\n      background: rgba($bw-primary, 0.05);\n      border-color: rgba($bw-primary, 0.25);\n    }\n\n    &__icon-box {\n      width: 64px;\n      height: 64px;\n      background: #fff;\n      border-radius: 50%;\n      display: grid;\n      place-items: center;\n      color: rgba($bw-primary, 0.4);\n      margin-bottom: 20px;\n      box-shadow: 0 10px 25px rgba(0,0,0,0.05);\n    }\n\n    &__title {\n      font-size: 18px;\n      font-weight: 800;\n      color: $bw-text;\n      margin: 0 0 8px;\n      letter-spacing: -0.02em;\n    }\n\n    &__text {\n      font-size: 14px;\n      color: $bw-muted;\n      margin: 0;\n      max-width: 280px;\n      line-height: 1.5;\n    }\n  }\n}\n\n.wallet-preview {\n  &__label { font-size: 13px; opacity: 0.6; display: block; margin-bottom: 8px; }\n  &__balance { \n    font-size: 32px; \n    font-weight: 800; \n    margin: 0 0 24px; \n    letter-spacing: -0.04em; \n    color: #fff;\n    @media (max-width: 480px) {\n      font-size: 26px;\n      margin-bottom: 16px;\n    }\n  }\n  &__btn {\n    display: inline-flex;\n    color: $bw-primary;\n    text-decoration: none;\n    font-weight: 800;\n    font-size: 13px;\n    padding: 10px 16px;\n    background: rgba(255,255,255,0.05);\n    border-radius: 12px;\n    transition: all 0.2s;\n\n    &:hover { background: rgba(255,255,255,0.1); color: #fff; }\n  }\n}\n\n.patient-to-pro-banner {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 24px;\n}\n\n.patient-to-pro-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    background-color: #f1f5f9;\n    color: #475569;\n    padding: 8px 16px;\n    border-radius: 8px;\n    font-weight: 600;\n    font-size: 14px;\n    text-decoration: none;\n    transition: all 0.2s ease;\n    border: 1px solid #e2e8f0;\n\n    &:hover {\n        background-color: #e2e8f0;\n        color: #0f172a;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `DashboardProfessional_dashboard__2Fe8o`,
	"dashboard__grid": `DashboardProfessional_dashboard__grid__6cYsV`,
	"dashboard__sidebar": `DashboardProfessional_dashboard__sidebar__9u4az`,
	"section-head": `DashboardProfessional_section-head__wWEDM`,
	"journey": `DashboardProfessional_journey__3gYYE`,
	"journey__head": `DashboardProfessional_journey__head__h5qLI`,
	"journey__mark": `DashboardProfessional_journey__mark__Smwrz`,
	"journey__title": `DashboardProfessional_journey__title__hTb3X`,
	"journey__subtitle": `DashboardProfessional_journey__subtitle__VIVI6`,
	"metrics": `DashboardProfessional_metrics__UkwjT`,
	"metric": `DashboardProfessional_metric__-BBwO`,
	"metric--income": `DashboardProfessional_metric--income__AmgLB`,
	"metric--appointments": `DashboardProfessional_metric--appointments__EOpsb`,
	"metric__icon-box": `DashboardProfessional_metric__icon-box__aiugq`,
	"metric__label": `DashboardProfessional_metric__label__wBEAg`,
	"metric__value": `DashboardProfessional_metric__value__5vxys`,
	"metric__note": `DashboardProfessional_metric__note__z+tlD`,
	"metric__content": `DashboardProfessional_metric__content__-fa7W`,
	"card-widget": `DashboardProfessional_card-widget__9SsC5`,
	"card-widget__header": `DashboardProfessional_card-widget__header__GPQ7y`,
	"card-widget__icon": `DashboardProfessional_card-widget__icon__xUxfd`,
	"card-widget__title": `DashboardProfessional_card-widget__title__H81uS`,
	"card-widget--dark": `DashboardProfessional_card-widget--dark__XVfg4`,
	"appointment-row": `DashboardProfessional_appointment-row__8pSZD`,
	"appointment-row__time": `DashboardProfessional_appointment-row__time__jj6Qb`,
	"appointment-row__date": `DashboardProfessional_appointment-row__date__Utcqv`,
	"appointment-row__hour": `DashboardProfessional_appointment-row__hour__QsSBf`,
	"appointment-row__info": `DashboardProfessional_appointment-row__info__oe2OK`,
	"appointment-row__name": `DashboardProfessional_appointment-row__name__SM18J`,
	"appointment-row__type": `DashboardProfessional_appointment-row__type__7pc9s`,
	"appointment-row__btn": `DashboardProfessional_appointment-row__btn__lCf+r`,
	"occupancy": `DashboardProfessional_occupancy__TGdfh`,
	"occupancy__chart": `DashboardProfessional_occupancy__chart__GmJrV`,
	"occupancy__center": `DashboardProfessional_occupancy__center__8q8u9`,
	"occupancy__legend": `DashboardProfessional_occupancy__legend__KDEyJ`,
	"widget-card": `DashboardProfessional_widget-card__cwwHf`,
	"widget-card__header": `DashboardProfessional_widget-card__header__jXVl2`,
	"widget-card__icon-box": `DashboardProfessional_widget-card__icon-box__9PmfF`,
	"widget-card__icon-box--green": `DashboardProfessional_widget-card__icon-box--green__XRUTW`,
	"widget-card__eyebrow": `DashboardProfessional_widget-card__eyebrow__oxfgH`,
	"widget-card__title": `DashboardProfessional_widget-card__title__eSZ2l`,
	"widget-card--dark": `DashboardProfessional_widget-card--dark__byElH`,
	"appointment-item": `DashboardProfessional_appointment-item__Vbkoh`,
	"appointment-item__time-box": `DashboardProfessional_appointment-item__time-box__5F4p0`,
	"appointment-item__date": `DashboardProfessional_appointment-item__date__XMX7Q`,
	"appointment-item__hour": `DashboardProfessional_appointment-item__hour__UybPj`,
	"appointment-item__info": `DashboardProfessional_appointment-item__info__0gRQm`,
	"appointment-item__patient": `DashboardProfessional_appointment-item__patient__kiUWc`,
	"appointment-item__reason": `DashboardProfessional_appointment-item__reason__i3nl5`,
	"appointment-item__link": `DashboardProfessional_appointment-item__link__Hy+TA`,
	"occupancy__value": `DashboardProfessional_occupancy__value__KJpI+`,
	"legend-item": `DashboardProfessional_legend-item__16n8o`,
	"legend-item__dot": `DashboardProfessional_legend-item__dot__Hj3Fa`,
	"legend-item__dot--occupied": `DashboardProfessional_legend-item__dot--occupied__IPXr0`,
	"legend-item__dot--free": `DashboardProfessional_legend-item__dot--free__TSRVU`,
	"agenda-list": `DashboardProfessional_agenda-list__p8KW0`,
	"agenda-list--empty": `DashboardProfessional_agenda-list--empty__wBSoL`,
	"agenda-list--empty__icon-box": `DashboardProfessional_agenda-list--empty__icon-box__Xg2Eq`,
	"agenda-list--empty__title": `DashboardProfessional_agenda-list--empty__title__IqGg9`,
	"agenda-list--empty__text": `DashboardProfessional_agenda-list--empty__text__1CewF`,
	"wallet-preview__label": `DashboardProfessional_wallet-preview__label__fXDKg`,
	"wallet-preview__balance": `DashboardProfessional_wallet-preview__balance__di9ZA`,
	"wallet-preview__btn": `DashboardProfessional_wallet-preview__btn__1+rAN`,
	"patient-to-pro-banner": `DashboardProfessional_patient-to-pro-banner__UseMr`,
	"patient-to-pro-btn": `DashboardProfessional_patient-to-pro-btn__Q4cNw`
};
export default ___CSS_LOADER_EXPORT___;
